import React, { useRef } from "react";
import { ACCEPTED_FILE_TYPES } from "../../../constants";
import { showPopUp } from "../../utils/Overlay";
import ContentFiles from "../ContentFiles";
import { verifyMaxNumberOfContentItems } from "./utils";
import Image from "../../utils/icons/Image";
import { trackEvent } from "../../helpers";

export default function AddFile({
  post,
  buttonClassName,
  noIcon,
}: {
  post: Post;
  buttonClassName?: string;
  noIcon?: boolean;
}) {
  const fileInput = useRef(null);

  const handleFileUpload = (event) => {
    showPopUp(
      <ContentFiles
        filesToUpload={event.target.files}
        post={post}
        onSuccess={() => {}}
      />
    );
  };

  return (
    <>
      <input
        type="file"
        className="hidden"
        ref={fileInput}
        onChange={handleFileUpload}
        multiple
        accept={ACCEPTED_FILE_TYPES.join(",")}
      />
      <button
        type="button"
        className={
          buttonClassName ? buttonClassName : "primary with-icon mr1 mb1"
        }
        onClick={() => {
          trackEvent("add-content-file");
          if (verifyMaxNumberOfContentItems(post.content)) {
            fileInput.current.click();
          }
        }}
      >
        {!noIcon && <Image size={20} />} Add a file
      </button>
    </>
  );
}
